import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../../constants'
import * as list from './list'
import * as stage from './stage'

export * as list from './list'
export * as stage from './stage'

export const actions = {
  ...stage.actions,
  ...list.actions,
}

export const epics = [...stage.epics, ...list.epics]

export const reducer = combineReducers({
  list: list.reducer,
  stage: stage.reducer,
})

export const selectors = {
  list: ({ [REDUCER_INDEX]: { stages: state } }: { [REDUCER_INDEX]: { stages: ReturnType<typeof reducer> } }) =>
    state.list,
  stage: ({ [REDUCER_INDEX]: { stages: state } }: { [REDUCER_INDEX]: { stages: ReturnType<typeof reducer> } }) =>
    state.stage,
}
